import { useInfiniteQuery } from 'react-query'
import { getTransactions } from 'services/transactions'

export default function useGetTransactions(q: string, date?: string) {
    return useInfiniteQuery(
        // Its own key: this used to share `money-pools-detail-users-in-funds`
        // with a fund's member list, so invalidating one refetched the other.
        ['my-transactions', q, date ?? ''],
        ({ pageParam = 1 }) => getTransactions({ cursor: pageParam, q, date }),
        {
            // `next` is read as a flag, not followed: with `q` or `date` on the
            // query string the server's own link comes out malformed.
            getNextPageParam: (lastPage, allPages) =>
                lastPage?.next ? allPages.length + 1 : undefined,
        }
    )
}
